import {useEffect} from 'react'
import {useParams, useNavigate} from 'react-router-dom'

import useFetch from 'shared/model/useFetch'
import useAlertModalAtom from 'shared/model/useAlertModalAtom'
import useRoleCookie from 'shared/model/useRoleCookie'
import getApiRolePath from 'shared/utils/getApiRolePath'

const useDeleteAccountBan = () => {
	const navigate = useNavigate()
	const {idx} = useParams()
	const [userRole] = useRoleCookie()
	const [fetchResult, fetchRequest] = useFetch()
	const [, setAlert] = useAlertModalAtom()

	const request = () => {
		const rolePath = getApiRolePath(userRole)
		fetchRequest('DELETE', `/${rolePath}/account/${idx}/ban`)
	}

	useEffect(() => {
		switch (fetchResult?.statusCode) {
			case 200:
				window.location.reload()
				break
			case 400:
				if (fetchResult?.data?.error_code === 'account_idx')
					setAlert('사용자 idx를 확인해 주세요.')
				else setAlert('입력한 값의 형식이 잘못되었습니다.')
				break
			case 404:
				if (fetchResult?.data?.error_code === 1) {
					setAlert('사용자 데이터가 존재하지 않습니다.')
					navigate('/user')
				}
				break
			case 409:
				if (fetchResult?.data?.error_code === 1)
					setAlert('정지 상태가 아닌 사용자 입니다.')
				break
		}
	}, [fetchResult])

	return [request]
}

export default useDeleteAccountBan
